/* eslint-disable no-console */
/* eslint-disable max-lines-per-function */
import React, { JSX, useEffect, useState } from 'react';
import Styles from './exsistingSubscription.module.scss';
import ExistingSubscriptionCards from './ExsistingSubscriptionCards';

interface ExsistingModalSchema {
  exsistingSubscriptionData: any;
  onSubmit?: any;
  updatedContent?: any;
}

const ExsistingSubscriptionModal = ({
  onSubmit,
  exsistingSubscriptionData,
  updatedContent
}: ExsistingModalSchema): JSX.Element => {

  const [selectedCardIndex, setUpdateCss] = useState<any>(0);

  //updating Card-Border
  const updateBorderIndex = (key?: number) => {
    setUpdateCss(key);
  };

  //OnClick of continue Function
  const handleContinue = () => {
    const selectedSubscriptiondata = exsistingSubscriptionData?.[selectedCardIndex];
    onSubmit(selectedSubscriptiondata);
  };

  return (
    <>
      <div>
        <div>
          <div className='d-flex align-items-center justify-content-between'>
            <div>
              <div className={Styles.modalTitle}>
                {updatedContent?.P2Pheading}
              </div>
            </div>
            <div>
              <div className={Styles.modalHeader} />
            </div>
          </div>
          <div className={Styles.desc}>
            <p>
              {updatedContent?.P2Pdescription1?.content?.[0]?.content?.[0]?.text}
            </p>
            <p>
              {updatedContent?.P2Pdescription2?.content?.[0]?.content?.[0]?.text}
            </p>
          </div>
          <div className={Styles.body}>
            <>
              <div className={`${Styles.exsistingSubscriptionSubText}`}>
              </div>
              <div className={`${Styles.cardStyles}`}>
                {exsistingSubscriptionData?.length > 0 &&
                  (exsistingSubscriptionData || [])?.map((subscriptionData: any, index: number) => (
                    <ExistingSubscriptionCards
                      subscriptionData={subscriptionData}
                      cardIndex={index}
                      updateBorderMethod={updateBorderIndex}
                      selectedCardIndex={selectedCardIndex}
                      subscriptionCardsLength={exsistingSubscriptionData?.length}
                    />
                  ))}
              </div>
            </>
          </div>
          <div className={Styles.footer}>
            <button
              className={`${
                selectedCardIndex !== undefined ? Styles.continueButton : Styles.disableButton
              }`}
              onClick={handleContinue}
            >
              {updatedContent?.continueText}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default ExsistingSubscriptionModal;
